module.exports = __webpack_public_path__ + "static/media/B.35addca5.png";